/* eslint-disable no-unused-vars, no-console */
import $ from 'jquery';

$(() => {
  const videos = $('.js-video-init');

  if (!videos.length) {
    return;
  }

  require.ensure(['videojs-core', 'videojs-youtube'], (require) => {
    require('videojs-core');
    require('videojs-youtube');

    videos.each((i, item) => {
      const $video = $(item);
      const video = videojs($video[0]);

      video.on('play', (event) => {
        $(event.target).parents('.js-video-wrapper').find('.js-video-title').hide();
      });
    });
  });
});



// WEBPACK FOOTER //
// ./js/components/init-video.js